module.exports = __webpack_public_path__ + "static/media/microphone-alt.ecbcac13.svg";